import { store } from '@utils/configStore'
import affiliateReducer from './slices'

export const injectAffiliateManagement = () => store.injectReducer('affiliate', affiliateReducer)
